import type { TiersPricing, Pricing, PerUnitPricing, FixedPricing, TieredSubscriptionPricing, UsagePricing } from '@weft/types';
import { FixedPricingSchema, PRICING_MODELS, UsagePricingSchema } from '@weft/types';

export function isTiersPricing(pricing: Pricing): pricing is TiersPricing {
  return pricing.pricingModel === PRICING_MODELS.Tiers;
}

export function isTieredSubscriptionPricing(pricing: Pricing): pricing is TieredSubscriptionPricing {
  return pricing.pricingModel === PRICING_MODELS.TieredSubscription;
}

export function isPerUnitPricing(pricing: Pricing): pricing is PerUnitPricing {
  return pricing.pricingModel === PRICING_MODELS.PerUnit;
}

export function isFixedPricing(pricing: Pricing): pricing is FixedPricing {
  return FixedPricingSchema.safeParse(pricing).success;
}

export function isUsagePricing(pricing: Pricing): boolean {
  return UsagePricingSchema.safeParse(pricing).success;
}

export function validateUsagePricing(pricing: Pricing): asserts pricing is UsagePricing {
  if (!isPerUnitPricing(pricing) && !isTiersPricing(pricing) && !isTieredSubscriptionPricing(pricing)) {
    throw new Error('Unsupported pricing model');
  }
}

export function validatePerUnitPricing(pricing: Pricing): asserts pricing is PerUnitPricing {
  if (!isPerUnitPricing(pricing)) {
    throw new Error('Pricing is not PerUnitPricing');
  }
}